import { AppRoute } from '@/modules/settings/types'
import { ImportsHomeCards } from './pages'
import { IMPORTS_ROUTES } from './routes-typed'

export const importsRoutesMap: Record<string, string> = {
  importHomeCards: IMPORTS_ROUTES.importHomeCards.path,
}

export const importsRoutes: AppRoute[] = [
  {
    path: importsRoutesMap.importHomeCards,
    component: ImportsHomeCards,
    exact: true,
  },
]
